import { Button } from '@any-ui-react/core';
import classNames from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import { Link } from 'react-router';

import { Card } from '@/common/components/shared/card';

interface Props {
  action?: ReactNode;
  className?: string;
  link?: string;
  linkTitle?: string;
  title: string;
}

export const DashboardSection = ({ action, children, className, link, linkTitle, title }: PropsWithChildren<Props>) => (
  <Card className={classNames('rounded-lg', className)}>
    <div className="mb-4 flex flex-wrap gap-2 items-center justify-between">
      <h2 className="text-lg font-semibold">{title}</h2>
      {link && (
        <Link className="text-link" to={link}>
          <Button className="bg-white" variant="default">
            {linkTitle ?? 'Details'}
          </Button>
        </Link>
      )}
      {action}
    </div>
    <div>{children}</div>
  </Card>
);
